import React from "react";
import Modal from "../../containers/Modal";
import {Grid, Col} from "../../styles/Grid";
import styled from "styled-components";
import {flexCreator} from "../../hooks/helpers";
import {AppButton} from "../../styles/Butttons";

export default function DeleteModal({isOpen, close, theme, confirm, showSuccess}) {
   return (
      <Modal
         type="delete"
         isOpen={isOpen}
         close={() => {
            close();
         }}
         theme={theme}
      >
         <Grid>
            <Col large="12">
               <p className="title">¡CUIDADO!</p>
            </Col>
            <Col large="12">
               <p className="text">¿Estás seguro de querer eliminarlo?</p>
            </Col>
            <ButtonContainer>
               <AppButton className="btn" onClick={confirm}>
                  ELIMINAR
               </AppButton>
               <AppButton className="btn" onClick={close}>
                  cancelar
               </AppButton>
            </ButtonContainer>
         </Grid>
      </Modal>
   );
}

const ButtonContainer = styled.div`
   ${flexCreator("around", "center")};
   margin-top: 2em;
   width: 100%;

   button.btn {
      padding: 0.5em 1.5em;
      background: white;
      color: #1c355e;
      font-size: 1em;
      font-weight: 600;
      border: 1px solid #1c355e;
      text-transform: uppercase;
   }
`;

/* deleteConfig={{
            deleteMessage: `¿Estás seguro de querer eliminarlo? ${id}`,
            cancelButton: "Cancelar",
            acceptButton: deleteAction,
         }} */
